import React from "react";
import * as Animate from "react-reveal";
import { Link } from "react-router-dom";
import { scholarshipCategories } from "../data/scholarshipCategories";

const APPLY_URL = "/mba/scholarships/apply";

const scholarships = scholarshipCategories.map((item, i) => ({
  number: `0${i + 1}`,
  percent: item.percent,
  image: item.image,
  alt: item.cardAlt,
  title: item.cardTitle,
  copy: item.copy,
  applyUrl: `${APPLY_URL}?scholarship=${item.id}`,
}));

const funnel = [
  { number: "01", title: "Discover", copy: "Compare four categories" },
  { number: "02", title: "Verify", copy: "Complete one short application" },
  { number: "03", title: "Decision", copy: "Approved or declined" },
  { number: "04", title: "Enroll", copy: "Complete Global MBA enrollment" },
];

const MBAScholarshipSection = () => {
  return (
    <section
      className="bg-hire-tint-yellow py-16 md:py-24 lg:py-28 px-4"
      id="scholarships"
    >
      <div className="container mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-mba-scholarship-heading gap-6 lg:gap-20 items-end mb-9 lg:mb-11">
          <Animate.Fade bottom>
            <div>
              <p className="flex items-center gap-3 font-poppins text-primary text-sm font-extrabold tracking-widest uppercase mb-5">
                <span className="w-8 h-0.5 bg-secondary inline-block flex-shrink-0"></span>
                Global MBA scholarships
              </p>
              <h2 className="font-poppins text-primary font-bold tracking-tight text-[35px] md:text-[49px] leading-[1.11] max-w-[780px] m-0">
                Scholarships available.{" "}
                <em className="bg-secondary text-primary not-italic px-[0.08em] box-decoration-clone">
                  Get up to 50% tuition support.
                </em>
              </h2>
            </div>
          </Animate.Fade>
          <Animate.Fade bottom>
            <div>
              <p className="font-poppins text-gray text-base leading-loose mb-4">
                Choose the category that fits your professional journey. Each
                scholarship has a dedicated eligibility page and leads to one
                short verification application.
              </p>
              <Link
                to={APPLY_URL}
                className="text-primary font-poppins text-base font-extrabold underline underline-offset-[5px]"
              >
                Go directly to the application <span aria-hidden="true">↗</span>
              </Link>
            </div>
          </Animate.Fade>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3.5">
          {scholarships.map((item) => (
            <Animate.Fade bottom key={item.number}>
              <article className="bg-white border border-[#e6dcc3] rounded-[21px] min-h-[520px] flex flex-col px-5 pt-3 pb-6 overflow-hidden shadow-[0_17px_43px_#1e20270e] transition-transform hover:-translate-y-1 hover:shadow-[0_22px_50px_#1e20271a] group">
                <figure className="relative m-0 -mx-2.5 mb-[18px] h-[205px] rounded-2xl overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.alt}
                    loading="lazy"
                    className="object-cover w-full h-full transition-transform duration-300 group-hover:scale-[1.035]"
                  />
                  <figcaption className="bg-[#fffffff0] rounded-[11px] justify-between items-center flex px-3.5 py-3 absolute inset-x-2.5 bottom-2.5">
                    <span className="font-poppins text-[#9a6500] text-[15px] font-extrabold">
                      {item.number}
                    </span>
                    <b className="font-poppins text-primary tracking-[-0.05em] text-[37px] leading-none font-bold">
                      {item.percent}
                    </b>
                  </figcaption>
                </figure>
                <p className="font-poppins text-[#9a6500] text-[15px] font-bold mt-2 mb-0">
                  Tuition scholarship
                </p>
                <h3 className="font-poppins text-primary font-semibold text-2xl leading-snug my-3">
                  {item.title}
                </h3>
                <p className="font-poppins text-gray text-base leading-relaxed min-h-[80px] mb-5">
                  {item.copy}
                </p>
                <Link
                  to={item.applyUrl}
                  className="mt-auto border-t border-hire-line text-primary justify-between items-center gap-4 pt-[18px] font-poppins text-base font-extrabold flex"
                >
                  View scholarship <span aria-hidden="true">↗</span>
                </Link>
              </article>
            </Animate.Fade>
          ))}
        </div>

        <Animate.Fade bottom>
          <div
            className="bg-primary text-white rounded-2xl grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-mba-scholarship-funnel items-center gap-3.5 mt-6 px-6 py-5"
            aria-label="Scholarship journey"
          >
            {funnel.map((step, i) => (
              <React.Fragment key={step.number}>
                <div className="grid grid-cols-[36px_1fr] items-center gap-x-2.5">
                  <span className="bg-secondary w-9 h-9 text-primary rounded-full row-span-2 grid place-items-center font-poppins text-sm font-extrabold">
                    {step.number}
                  </span>
                  <strong className="font-poppins text-base font-semibold">
                    {step.title}
                  </strong>
                  <small className="text-[#d5ddff] text-sm mt-0.5 col-start-2">
                    {step.copy}
                  </small>
                </div>
                {i < funnel.length - 1 && (
                  <i
                    aria-hidden="true"
                    className="hidden lg:block text-secondary text-xl not-italic justify-self-center"
                  >
                    →
                  </i>
                )}
              </React.Fragment>
            ))}
          </div>
        </Animate.Fade>
      </div>
    </section>
  );
};

export default MBAScholarshipSection;
